import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const baseURL = process.env.REACT_APP_BASE_URL;

export const createCodeAction = createAsyncThunk(
  "code/create",
  async (info, { rejectWithValue, getState, dispatch }) => {
    try {
      const user = getState()?.users;
      const { userAuth } = user;

      const config = {
        headers: {
          Authorization: `Bearer ${userAuth?.token}`,
        },
      };
      const { data } = await axios.post(
        `${baseURL}/api/code`,
        {
          name: info?.name,
          code: info?.code,
        },
        config
      );
      return data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchCodesAction = createAsyncThunk(
  "code/fetch",
  async (info, { rejectWithValue, getState, dispatch }) => {
    try {
      const user = getState()?.users;
      const { userAuth } = user;

      const config = {
        headers: {
          Authorization: `Bearer ${userAuth?.token}`,
        },
      };
      const { data } = await axios.get(
        `${baseURL}/api/code`,

        config
      );
      return data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getCodeAction = createAsyncThunk(
  "code/get",

  async (id, { rejectWithValue, getState, dispatch }) => {
    try {
      const user = getState()?.users;
      const { userAuth } = user;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userAuth?.token}`,
        },
      };

      const { data } = await axios.get(`${baseURL}/api/code/${id}`, config);
      return data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateCodeAction = createAsyncThunk(
  "code/update",

  async (info, { rejectWithValue, getState, dispatch }) => {
    try {
      const user = getState()?.users;
      const { userAuth } = user;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userAuth?.token}`,
        },
      };
      const { data } = await axios.put(
        `${baseURL}/api/code/${info.id}`,
        {
          name: info?.name,
          code: info?.code,
        },
        config
      );
      return data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteCodeAction = createAsyncThunk(
  "code/delete",

  async (id, { rejectWithValue, getState, dispatch }) => {
    const info = getState();
    const user = getState()?.users;
    const { userAuth } = user;
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${userAuth?.token}`,
        },
      };
      const { data } = await axios.delete(`${baseURL}/api/code/${id}`, config);
      return data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

const codeSlices = createSlice({
  name: "code",
  initialState: {},
  extraReducers: (builder) => {
    builder.addCase(createCodeAction.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(createCodeAction.fulfilled, (state, action) => {
      state.loading = false;
      state.code = action?.payload;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(createCodeAction.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload.message;
      state.serverErr = action?.error?.message;
    });
    builder.addCase(fetchCodesAction.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchCodesAction.fulfilled, (state, action) => {
      state.loading = false;
      state.codes = action?.payload;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(fetchCodesAction.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload.message;
      state.serverErr = action?.error?.message;
    });

    //Get   By Id
    builder.addCase(getCodeAction.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getCodeAction.fulfilled, (state, action) => {
      state.loading = false;
      state.getCode = action?.payload;

      state.appError = undefined;
      state.serverError = undefined;
    });

    builder.addCase(getCodeAction.rejected, (state, action) => {
      state.loading = false;
      state.appError = action?.payload?.message;
      state.serverError = action?.error?.message;
    });

    //Update   By Id
    builder.addCase(updateCodeAction.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(updateCodeAction.fulfilled, (state, action) => {
      state.loading = false;
      state.updateCode = action?.payload;

      state.appError = undefined;
      state.serverError = undefined;
    });

    builder.addCase(updateCodeAction.rejected, (state, action) => {
      state.loading = false;
      state.appError = action?.payload?.message;
      state.serverError = action?.error?.message;
    });

    //Delete
    builder.addCase(deleteCodeAction.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(deleteCodeAction.fulfilled, (state, action) => {
      state.loading = false;
      state.deleteCode = action?.payload;

      state.appError = undefined;
      state.serverError = undefined;
    });

    builder.addCase(deleteCodeAction.rejected, (state, action) => {
      state.loading = false;
      state.appError = action?.payload?.message;
      state.serverError = action?.error?.message;
    });
  },
});

export default codeSlices.reducer;
